import PageHeader from "@/components/PageHeader";
import { ShieldCheck, Scale, Lock, Image as ImageIcon, Instagram } from "lucide-react";

const Section = ({ icon: Icon, title, children }) => (
  <div className="border border-white/10 rounded-sm bg-secondary p-6">
    <div className="flex items-center gap-3 mb-3">
      <Icon className="h-5 w-5 text-accent" />
      <h2 className="font-heading text-lg font-bold tracking-tight">{title}</h2>
    </div>
    <div className="text-sm text-muted-foreground leading-relaxed space-y-2">{children}</div>
  </div>
);

export default function Legal() {
  return (
    <>
      <PageHeader overline="Conformité & mentions" title="Légal" />
      <div className="p-6 lg:p-8 max-w-3xl space-y-6">
        <p className="text-sm text-muted-foreground">
          NATYE est un outil professionnel privé de gestion de réseaux sociaux. Cette page
          résume le cadre légal d'utilisation. Ce résumé est informatif et ne remplace pas un
          conseil juridique ; fais valider tes documents (mentions légales, CGU, RGPD) par un
          professionnel avant toute exploitation commerciale.
        </p>

        <Section icon={Scale} title="Mentions légales">
          <p>
            Éditeur : à compléter (raison sociale, statut, SIREN/SIRET, adresse, e-mail de contact,
            directeur de la publication). Hébergement : à compléter (nom et adresse de l'hébergeur).
          </p>
          <p>
            Marque « NATYE » : vérifie la disponibilité et effectue un dépôt auprès de l'INPI
            avant toute communication commerciale afin de sécuriser tes droits.
          </p>
        </Section>

        <Section icon={ImageIcon} title="Droits sur les visuels et contenus">
          <p>
            Tu déclares disposer des droits nécessaires (ou d'un mandat écrit de la marque cliente)
            sur les visuels importés depuis les sites des marques et sur les contenus publiés. Le
            scraping ne doit porter que sur des sites pour lesquels tu es autorisé(e) à agir.
          </p>
          <p>
            Les visuels générés par IA sont des créations assistées : tu restes responsable de leur
            conformité (droits d'auteur, marques, ressemblance, mentions publicitaires). Signale les
            contenus sponsorisés conformément à la réglementation (ex. #publicité / partenariat).
          </p>
        </Section>

        <Section icon={Instagram} title="Automatisation Instagram">
          <p>
            La publication automatique utilise l'API officielle Instagram Graph (Meta). Tu dois
            respecter les Conditions d'utilisation de la plateforme Meta et les règles
            communautaires. Chaque marque connecte son propre compte Instagram Business/Créateur via
            un jeton d'accès dont elle est responsable.
          </p>
          <p>
            Aucun mot de passe Instagram n'est demandé ni stocké : seule l'API officielle est
            utilisée. Tu peux déconnecter un compte à tout moment.
          </p>
        </Section>

        <Section icon={Lock} title="Données personnelles (RGPD)">
          <p>
            NATYE stocke : comptes utilisateurs (e-mail, mot de passe chiffré), fiches marques,
            produits importés, posts et visuels générés. Base légale : exécution du contrat / intérêt
            légitime. Les mots de passe sont hachés (bcrypt) et jamais stockés en clair.
          </p>
          <p>
            Droits des personnes (accès, rectification, effacement, portabilité, opposition) : à
            exercer auprès du responsable de traitement (à compléter). Conserve les données le temps
            strictement nécessaire et sécurise les accès (comptes nominatifs, mots de passe forts).
          </p>
        </Section>

        <Section icon={ShieldCheck} title="Conditions d'utilisation">
          <p>
            L'accès est réservé aux utilisateurs disposant d'identifiants créés par l'administrateur.
            Chaque utilisateur est responsable de la confidentialité de ses identifiants et des
            contenus qu'il publie via l'outil.
          </p>
        </Section>
      </div>
    </>
  );
}
